import React from 'react';

import Soon from '../soon/Soon.js';
import Bridge from '../bridge/Bridge.js';
import Privacy from '../privacy/Privacy.js';

import './Header.css';

function Header(props) {
    return(
    	<div className="ghost-header">
	    <div className="ghost-header-inner">
	    	<Bridge />
	    	<Privacy />
	    	<Soon text={'Airdrop'} />
	    	<Soon text={'Network'} />
	    	<div className="ghost-header-button" onClick={() => props.setMain(false)}>AstralVM</div>
	    </div>
	</div>
    );
}

export default Header;
